import { useState, useEffect, useContext } from "react";
import { ThemeContext } from "../../layout/BaseLayout";
import Draggable from "react-draggable";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { ModalDialog } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import * as ModuleMasterService from "../../services/moduleMasterService";
import { Loader } from "../../utils/loader";
import NoDataError from "../../components/NoDataError";

const feedModuleAddModalDragModal = (props) => {
   return (
      <Draggable handle=".modal-header">
         <ModalDialog {...props} />
      </Draggable>
   );
};

function ModuleMaster(props) {
   let toast = useContext(ThemeContext);
   const [moduleMasterAddModalShow, setModuleMasterAddModalShow] = useState(false);
   const moduleMasterCreationDefaultObj = {
      "moduleFor": "Admin",
      "moduleName": "",
      "displayName": "",
      "parentModule": 0,
      "modulePosition": 1,
      "moduleUrl": "",
      "iconPath": "",
      "moduleDescription": "",
      "moduleAdd": false,
      "moduleEdit": false,
      "moduleDelete": false,
      "moduleView": false,
      "mapModules": [],
      'moduleId': 0,
      "moduleStatus": true
   }
   const [moduleMasterCreationObj, setModuleMasterCreationObj] = useState({ ...moduleMasterCreationDefaultObj });
   const [modulePositionList, setModulePositionList] = useState([]);
   const [modulePositionObj, setModulePositionObj] = useState({});
   const [parentModulesObj, setParentModulesObj] = useState({ "Admin": {}, "Admin-Menu": {}, "Admin-Other": {}, "Dealer": {}, "Dealer-Menu": {}, "Dealer-Other": {} });
   const [selectedModuleFor, setSelectedModuleFor] = useState("");
   const [isEdit, setIsEdit] = useState(false);
   const [loader, setLoader] = useState(false);
   const [disableSubmitBtn, setDisableSubmitBtn] = useState(false);
   const [moduleNameError, setModuleNameError] = useState(false);
   const [displayNameError, setDisplayNameError] = useState(false);
   const [selectedArr, setSelectedArr] = useState([]);

   const [groupingModuleMasterList, setGroupingModuleMasterList] = useState({});
   const [moduleMasterFilteredList, setModuleMasterFilteredList] = useState({});

   const [popupActiveTab, setPopupActiveTab] = useState(1);
   const [moduleForAdminDealer, setModuleForAdminDealer] = useState('Admin');
   const [groupingForMapModules, setGroupingForMapModules] = useState([]);
   const [filteredGroupingMapModules, setFilteredGroupingMapModules] = useState([]);
   const [searchByName, setSearchByName] = useState('');
   const [searchByStatus, setSearchByStatus] = useState();

   useEffect(() => {
      getModuleMaster();
      const rows = [];
      for (let i = 1; i <= 100; i++) {
         rows.push(<option value={i}>{i}</option>);
      }
      setModulePositionList([...rows])
   }, [])

   useEffect(() => {
      if (!!selectedModuleFor) {
         const valueToKeysMap = {
            "Admin": ["Admin-Other", "Admin-Menu", "Admin"],
            "Dealer": ["Dealer-Other", "Dealer-Menu", "Dealer"],
         };
         const keysToDisplay = valueToKeysMap[selectedModuleFor];
         if (keysToDisplay) {
            const filteredModuleMasterList = Object.keys(groupingModuleMasterList)
               .filter(key => keysToDisplay.includes(key))
               .reduce((result, key) => {
                  result[key] = groupingModuleMasterList[key];
                  return result;
               }, {});
            setModuleMasterFilteredList({...filteredModuleMasterList});

         }
      } else {
         setModuleMasterFilteredList({ ...groupingModuleMasterList });
      }
   }, [selectedModuleFor])

   const moduleMasterById = (moduleId) => {
      ModuleMasterService.getModuleMasterById(moduleId).then((res) => {
         if (res.isSuccess) {
            let tempMapModuleArr = [...moduleMasterFilteredList["Admin"] || [], ...moduleMasterFilteredList["Dealer"] || [], ...moduleMasterFilteredList["Admin-Other"] || [], ...moduleMasterFilteredList["Dealer-Other"] || []];
            let tempArray = [];
            if (!!res?.data) {
               tempMapModuleArr?.forEach((item) => {
                  let checkModuleId = false;
                  let tempObj = {
                     moduleAdd: false,
                     moduleDelete: false,
                     moduleEdit: false,
                     moduleView: false,
                     moduleId: item?.moduleId,
                     moduleFor: item?.moduleFor,
                     displayName: item?.displayName,
                  };
                  if (res?.data?.mapModules?.length > 0) {
                     res?.data?.mapModules?.forEach((val) => {
                        if (val?.moduleId === item?.moduleId) {
                           tempObj.moduleAdd = val?.moduleAdd;
                           tempObj.moduleDelete = val?.moduleDelete;
                           tempObj.moduleEdit = val?.moduleEdit;
                           tempObj.moduleView = val?.moduleView;
                           tempArray.push(tempObj);
                           checkModuleId = true;
                        }
                     });
                     if (!checkModuleId) {
                        tempArray.push(tempObj);
                     }
                  }
               });

               let tempGroupingForMapModules = [...tempArray];
               let filterAdminOrDealer = [];
               if (moduleForAdminDealer === 'Admin') {
                  filterAdminOrDealer = tempGroupingForMapModules.filter((item) => ['Admin', 'Admin-Other'].includes(item.moduleFor));
               } else if (moduleForAdminDealer === 'Dealer') {
                  filterAdminOrDealer = tempGroupingForMapModules.filter((item) => ['Dealer', 'Dealer-Other'].includes(item.moduleFor));
               }
               setGroupingForMapModules([...tempGroupingForMapModules]);
               setFilteredGroupingMapModules([...filterAdminOrDealer]);
            }
            setModuleMasterCreationObj(res.data);
            editModuleMasterAddModal()

         } else {
            toast.error(!!res && !!res.exception && !!res.exception.message && res.exception.message)
         }
      })
   }

   const onSubmitModuleMaster = () => {
      let isValid = true;
      setDisableSubmitBtn(true);
      if (moduleMasterCreationObj?.moduleName === '') {
         setModuleNameError(true);
         setDisableSubmitBtn(false);
         isValid = false;
      }

      if (moduleMasterCreationObj?.displayName === '') {
         setDisplayNameError(true);
         setDisableSubmitBtn(false);
         isValid = false;
      }
      let tempAccessRights = [];
      for (let i = 0; i < groupingForMapModules?.length; i++) {
         if (groupingForMapModules[i]?.moduleAdd === true || groupingForMapModules[i]?.moduleEdit === true || groupingForMapModules[i]?.moduleDelete === true || groupingForMapModules[i]?.moduleView === true) {
            tempAccessRights.push({
               moduleId: groupingForMapModules[i]['moduleId'],
               moduleAdd: groupingForMapModules[i]['moduleAdd'],
               moduleEdit: groupingForMapModules[i]['moduleEdit'],
               moduleDelete: groupingForMapModules[i]['moduleDelete'],
               moduleView: groupingForMapModules[i]['moduleView'],
            });
         }
      }
      let data = {
         moduleId: moduleMasterCreationObj?.moduleId,
         moduleName: moduleMasterCreationObj?.moduleName,
         modulePosition: moduleMasterCreationObj?.modulePosition,
         iconPath: moduleMasterCreationObj?.iconPath,
         moduleStatus: moduleMasterCreationObj?.moduleStatus,
         moduleName: moduleMasterCreationObj?.moduleName,
         parentModule: moduleMasterCreationObj?.parentModule,
         moduleUrl: moduleMasterCreationObj?.moduleUrl,
         moduleDescription: moduleMasterCreationObj?.moduleDescription,
         moduleFor: moduleMasterCreationObj?.moduleFor,
         displayName: moduleMasterCreationObj?.displayName,
         moduleAdd: moduleMasterCreationObj?.moduleAdd,
         moduleEdit: moduleMasterCreationObj?.moduleEdit,
         moduleDelete: moduleMasterCreationObj?.moduleDelete,
         moduleView: moduleMasterCreationObj?.moduleView,
         mapModules: [...tempAccessRights],
      };
      if (isValid) {
         if (!!isEdit) {
            ModuleMasterService.updateModuleMaster(data).then((res) => {
               if (res.isSuccess) {
                  toast.success(!!res && !!res.successMessage && res.successMessage)
                  closeModuleMasterAddModal()
                  getModuleMaster();
                  setSelectedModuleFor("")
                  setModuleMasterCreationObj({ ...moduleMasterCreationDefaultObj });
                  setFilteredGroupingMapModules([]);
                  setGroupingForMapModules([]);
                  setIsEdit(false);
                  setDisableSubmitBtn(false);
               } else {
                  toast.error(!!res && !!res.exception && !!res.exception.message && res.exception.message);
                  setDisableSubmitBtn(false);
               }
            }).catch(e => {
               setDisableSubmitBtn(false);
            })
         } else {
            delete data['moduleId'];
            ModuleMasterService.createModuleMaster(data).then((res) => {
               if (res.isSuccess) {
                  toast.success(!!res && !!res.successMessage && res.successMessage)
                  closeModuleMasterAddModal()
                  getModuleMaster()
                  setSelectedModuleFor("")
                  setFilteredGroupingMapModules([]);
                  setGroupingForMapModules([]);
                  setModuleMasterCreationObj({ ...moduleMasterCreationDefaultObj })
                  setIsEdit(false);
                  setDisableSubmitBtn(false);
               } else {
                  toast.error(!!res && !!res.exception && !!res.exception.message && res.exception.message);
                  setDisableSubmitBtn(false);
               }
            }).catch(e => {
               setDisableSubmitBtn(false);
            })
         }
      }
   }

   const getModuleMaster = () => {
      setLoader(true);
      ModuleMasterService.getAllModuleMaster().then((res) => {
         setLoader(false);
         if (res.isSuccess) {
            // let modules = !!res && !!res.data && res.data.sort((a, b) => { return a.modulePosition - b.modulePosition; });
            // modules = !!modules && modules.sort((a, b) => { return a.parentModule - b.parentModule; });
            // 
            // setModuleMasterFilteredList([...modules])
            const filteredModuleMaster = res?.data?.reduce((groups, item) => {
               const modulesGroup = item.moduleFor;
               if (!groups[modulesGroup]) {
                  groups[modulesGroup] = [];
               }
               groups[modulesGroup].push(item);
               return groups;
            }, {})
            setGroupingModuleMasterList({...filteredModuleMaster})
            setModuleMasterFilteredList({...filteredModuleMaster})
            let parentModules = { ...parentModulesObj }
            res?.data?.forEach(item => {
               if (["Admin", "Admin-Menu", "Admin-Other"]?.includes(moduleMasterCreationObj?.moduleFor)) {
                  if (["Admin", "Admin-Menu", "Admin-Other"]?.includes(item?.moduleFor)) {
                     parentModules[moduleMasterCreationObj?.moduleFor][item?.moduleId] = item?.displayName;
                  }
               } else if (["Dealer", "Dealer-Menu", "Dealer-Other"]?.includes(moduleMasterCreationObj?.moduleFor)) {
                  if (["Dealer", "Dealer-Menu", "Dealer-Other"]?.includes(item?.moduleFor)) {
                     parentModules[moduleMasterCreationObj?.moduleFor][item?.moduleId] = item?.displayName;
                  }
               }
            })
            setParentModulesObj({ ...parentModules })
            setLoader(false);
         } else {
            toast.error(!!res && !!res.exception && !!res.exception.message && res.exception.message);
            setLoader(false);
         }
      }).catch(e => {
         setLoader(false);
      })
   }

   useEffect(() => {
      if (moduleMasterAddModalShow) {
         getModuleMaster();
      }
   }, [moduleMasterCreationObj?.moduleFor])

   const onUpdateModulePosition = () => {
      if (!!modulePositionObj && Object.keys(modulePositionObj).length > 0) {

         let body = []
         Object.keys(modulePositionObj).forEach(key => {
            body.push({ "moduleId": key, "modulePosition": modulePositionObj[key] })
         });

         ModuleMasterService.updateModulePosition(body).then((res) => {
            if (res.isSuccess) {
               toast.success(!!res && !!res.successMessage && res.successMessage)
               setModulePositionObj({})
               setSelectedModuleFor("")
               getModuleMaster()
            } else {
               toast.error(!!res && !!res.exception && !!res.exception.message && res.exception.message)
            }
         })
      } else {
         toast.error(" No Any Position Changed !!!")
      }
   }

   const onChange = (event, val, type = "") => {
      let name = event.target.name
      let value;
      let changeModuleMasterObj = { ...moduleMasterCreationObj }

      if (type.includes("Rights")) {
         let item = val;
         let tempGroupingForMapModules = [...filteredGroupingMapModules];
         let index = tempGroupingForMapModules?.findIndex((itm) => item?.moduleId === itm?.moduleId);
         tempGroupingForMapModules[index][type?.split("-")[1]] = !tempGroupingForMapModules[index][type?.split("-")[1]];
         setFilteredGroupingMapModules([...tempGroupingForMapModules]);
      } else {
         if (['moduleAdd', 'moduleEdit', 'moduleDelete', 'moduleView'].includes(event.target.name)) {
            value = val
         } else {
            value = event.target.value
         }
      }

      if (name === "moduleStatus") {
         value = (value === 'true')
      } else if (name === "moduleFor") {
         changeModuleMasterObj.parentModule = 0
      }

      changeModuleMasterObj[name] = value;
      setModuleMasterCreationObj({ ...changeModuleMasterObj })
   }

   const onChangeModulePosition = (moduleId, position) => {
      let modulePosition = { ...modulePositionObj }
      modulePosition[moduleId] = parseInt(position)
      setModulePositionObj({ ...modulePosition })
   }

   const openModuleMasterAddModal = () => {
      let tempMapModuleArr = [...moduleMasterFilteredList["Admin"], ...moduleMasterFilteredList["Dealer"], ...moduleMasterFilteredList["Admin-Other"], ...moduleMasterFilteredList["Dealer-Other"]];
      let tempArray = [];
      tempMapModuleArr?.forEach((item) => {
         let checkModuleId = false;
         let tempObj = {
            moduleAdd: false,
            moduleDelete: false,
            moduleEdit: false,
            moduleView: false,
            moduleId: item?.moduleId,
            moduleFor: item?.moduleFor,
            displayName: item?.displayName,
         };
         if (!checkModuleId) {
            tempArray.push(tempObj);
         }
      });


      let tempGroupingForMapModules = [...tempArray];
      let filterAdminOrDealer = [];
      if (moduleForAdminDealer === 'Admin') {
         filterAdminOrDealer = tempGroupingForMapModules.filter((item) => ['Admin', 'Admin-Other'].includes(item.moduleFor));
      } else if (moduleForAdminDealer === 'Dealer') {
         filterAdminOrDealer = tempGroupingForMapModules.filter((item) => ['Dealer', 'Dealer-Other'].includes(item.moduleFor));
      }
      setGroupingForMapModules([...tempGroupingForMapModules]);
      setFilteredGroupingMapModules([...filterAdminOrDealer]);

      setModuleMasterAddModalShow(true);
   }

   const editModuleMasterAddModal = () => {
      setIsEdit(true)
      setModuleMasterAddModalShow(true);
   }

   const closeModuleMasterAddModal = () => {
      setModuleMasterCreationObj({ ...moduleMasterCreationDefaultObj });
      setFilteredGroupingMapModules([]);
      setGroupingForMapModules([]);
      setModuleMasterAddModalShow(false);
      setIsEdit(false);
      setDisplayNameError(false);
      setModuleNameError(false);
      setPopupActiveTab(1);
      setModuleForAdminDealer('Admin');
   }

   const onSelectionRow = (item) => {
      for (const moduleFor in moduleMasterFilteredList) {
         const moduleItems = moduleMasterFilteredList[moduleFor];
         const selectedRow = moduleItems.map((elem) => { return elem.moduleId }).indexOf(item.moduleId);
         if (selectedRow !== -1) {
            setSelectedArr([moduleItems[selectedRow]]);
         }
      }
   }

   const checkItem = (item) => {
      const checkData = !!selectedArr && selectedArr.some((val) => val?.moduleId === item?.moduleId)
      return checkData;
   }

   const onChangingOfSelection = (event) => {
      setModuleForAdminDealer(event);
      let tempGroupingForMapModules = [...groupingForMapModules];
      let filterAdminOrDealer;
      if (event === 'Admin') {
         filterAdminOrDealer = tempGroupingForMapModules.filter((item) => ['Admin', 'Admin-Other'].includes(item.moduleFor));
      } else if (event === 'Dealer') {
         filterAdminOrDealer = tempGroupingForMapModules.filter((item) => ['Dealer', 'Dealer-Other'].includes(item.moduleFor));
      }
      setFilteredGroupingMapModules([...filterAdminOrDealer])
   }

   const onChangeOfFilterByName = (event) => {
      setSearchByName(event);
      if (!!event) {
         const filteredObject = Object.fromEntries(
            Object.entries(moduleMasterFilteredList).map(([key, value]) => [
               key,
               value.filter((item) => item.moduleName.toLowerCase().includes(event.toLowerCase())),
            ])
         );
         setModuleMasterFilteredList({...filteredObject});
      } else {
         setModuleMasterFilteredList({ ...groupingModuleMasterList });
      }
   }

   const onChangeOfFilterByStatus = (event) => {
      setSearchByStatus(event);
      if (!!event) {
         const statusBoolean = event.toLowerCase() === 'active' ? true : event.toLowerCase() === 'inactive' ? false : null;
         if (statusBoolean !== null) {
            const filteredObjectforStatus = Object.fromEntries(
               Object.entries(groupingModuleMasterList).map(([key, value]) => [
                  key,
                  value.filter((item) => item.moduleStatus === statusBoolean),
               ])
            );
            setModuleMasterFilteredList({...filteredObjectforStatus});
         }
      } else {
         setModuleMasterFilteredList({ ...groupingModuleMasterList });
      }
   }

   return (
      <>
         <div id="tabs">
            {(!!loader && loader) && <Loader />}
            <div className="maintitle-box">
               <div className="w-50 d-inline-block">
                  <h2 className="maintitle "><img className="main-title-img" src={"/images/svg/module-master.svg"} alt="" />Module Master</h2>
               </div>
               <div className="align-center d-flex d-inline-block justify-content-end w-50">
                  <div className="d-inline-block mr-2"><i id="moduleMasterRefresh" className="fa fa-refresh font-size-14 remove_arrow_summary"
                     onClick={() => { getModuleMaster(); onChangeOfFilterByStatus("");  setSelectedModuleFor("")}}></i>
                  </div>
                  <div className="d-inline-block float-end  mr-2">
                     <div className="d-inline-block float-end  mr-2">
                        <input type="text" placeholder="Search By Module Name" value={searchByName} onChange={(e) => onChangeOfFilterByName(e.target.value)} />
                     </div>
                     <div className="d-inline-block float-end  mr-2">
                        <select className="form-select inputborder lic-status font11" value={searchByStatus} onChange={(e) => onChangeOfFilterByStatus(e.target.value)}>
                           <option value="">All</option>
                           <option value="Active">Active</option>
                           <option value="Inactive">Inactive</option>
                        </select>
                     </div>
                  </div>
                  <div className="d-inline-block float-end w-200 mr-2">
                     <select className="form-select inputborder w-100 font11" value={selectedModuleFor} onChange={(e) => { setSelectedModuleFor(e.target.value) }}>
                        <option value="">All</option>
                        <option value="Admin">Admin</option>
                        <option value="Dealer">Dealer</option>
                     </select>
                  </div>

                  <div className="float-end ">
                     <button className="addnewbtn mb-0" onClick={() => { openModuleMasterAddModal() }}>
                        <i className="fa-solid fa-circle-plus mr-2"></i>Add
                     </button>
                  </div>



               </div>
            </div>
            {Object.keys(moduleMasterFilteredList).length > 0 && Object.entries(moduleMasterFilteredList).map(([modFor, groups]) => ({ modFor, groups })).sort((a, b) => a.modFor.localeCompare(b.modFor)).map(({ modFor, groups }) => {
               const sortedGroups = groups.sort((a, b) => a.modulePosition - b.modulePosition);
               return (
                  <div className="thead-fixed" key={`${modFor}_modules`}>
                     <div className='font-13 font-bold ml-2'>{modFor}</div>
                     <table className="table table-bordered table-strip w-100 mb-30">
                        <thead>
                           <tr className="thead-dard-bg">
                              <th className=" srn-width">Sr</th>
                              <th className="feed-m-name">Module For</th>
                              <th className="lic-domain">Module Name</th>
                              <th className="">Display Name</th>
                              <th className="">Parent Module</th>
                              <th className="">Module Position <i className="fas fa-save fa-lg ml-2" onClick={() => { onUpdateModulePosition() }}></i></th>
                              <th className="">Module URL</th>
                              <th className="">Icon Path</th>
                              <th className="lic-status">Status</th>
                           </tr>
                        </thead>
                        <tbody>
                           {!!sortedGroups && sortedGroups.sort((a, b) => b.moduleStatus - a.moduleStatus).map((item, i) => {
                              return (
                                 <tr key={`${item.moduleId}_${i}`} className={`${!item.moduleStatus && "text-pink"} ${checkItem(item) ? 'selected-tr' : ''}`} onDoubleClick={() => { moduleMasterById(item.moduleId) }} onClick={() => onSelectionRow(item)}>
                                    <td className="">{i + 1}</td>
                                    <td className="">{item.moduleFor}</td>
                                    <td className="">{item.moduleName}</td>
                                    <td className="">{item.displayName}</td>
                                    <td className="">{item.parentModule}</td>
                                    <td className="">
                                       <select className="form-select inputborder w-100 font11" name="modulePositionChange" value={(!!modulePositionObj && item.moduleId in modulePositionObj) ? modulePositionObj[item.moduleId] : item.modulePosition} onChange={(e) => { onChangeModulePosition(item.moduleId, e.target.value) }}>
                                          {modulePositionList}
                                       </select>
                                    </td>
                                    <td className="">{item.moduleUrl}</td>
                                    <td className="">{item.iconPath}</td>
                                    <td className="">{item.moduleStatus ? "Active" : "Inactive"}</td>
                                 </tr>
                              )
                           })}
                        </tbody>
                     </table>
                  </div>
               )
            })}
         </div>
         <div className="login-popup">
            <Modal
               className="newsymbol   feed-modules"
               show={moduleMasterAddModalShow}
               onHide={() => closeModuleMasterAddModal()}
               backdrop="static"
               dialogAs={feedModuleAddModalDragModal}
               animation={false}
               size="md"
               centered
            >
               <Modal.Header closeButton style={{ border: "none" }}>
                  <Modal.Title className="w-100">
                     Module Modules
                     <div className="btn-help d-inline-block float-right ">
                     </div>
                  </Modal.Title>
               </Modal.Header>
               <Modal.Body style={{ display: "flex", flexDirection: "column" }}>
                  <div className="p-1">
                     <div className="feederbox">
                        <div className="container p-0">
                           <ul className="nav nav-tabs">
                              <li className="nav-item">
                                 <a
                                    className={
                                       popupActiveTab === 1 ? "nav-link active" : "nav-link"
                                    }
                                    onClick={() => {
                                       setPopupActiveTab(1);
                                    }}
                                 >
                                    Modules
                                 </a>
                              </li>
                              <li className="nav-item">
                                 <a
                                    className={
                                       popupActiveTab === 2 ? "nav-link active" : "nav-link"
                                    }
                                    onClick={() => {
                                       setPopupActiveTab(2);
                                    }}
                                 >
                                    Map Modules
                                 </a>
                              </li>
                           </ul>
                           {popupActiveTab === 1 &&
                              <div className="fidderbox-inner office-height-modulemaster ">
                                 <div className="row">
                                    <div className="col-6">
                                       <div className="mb-1 row prl-7">
                                          <label htmlFor="inputDigit" className="col-sm-5 font11 text-right p-0 line-h20 mb-0">Module For :</label>
                                          <div className="col-sm-7 pl-2 pr-0">
                                             <select className="form-select inputborder w-100 font11" name="moduleFor" value={!!moduleMasterCreationObj.moduleFor ? moduleMasterCreationObj.moduleFor : ""} onChange={(e) => { onChange(e) }} autoFocus>
                                                <option value="Admin">Admin</option>
                                                <option value="Admin-Menu">Admin-Menu</option>
                                                <option value="Admin-Other">Admin-Other</option>
                                                <option value="Dealer">Dealer</option>
                                                <option value="Dealer-Menu">Dealer-Menu</option>
                                                <option value="Dealer-Other">Dealer-Other</option>
                                             </select>
                                          </div>
                                       </div>
                                       <div className="mb-1 row prl-7">
                                          <label htmlFor="inputSymbol" className="col-sm-5 font11 text-right p-0 line-h20 mb-0">Display Name:</label>
                                          <div className={`col-sm-7 p-0 pl-2 ${displayNameError && 'error'}`}>
                                             <input type="text" className="inputborder font11 w-100 h20" maxLength="50" name="displayName" value={moduleMasterCreationObj.displayName} autoComplete="off" onChange={(e) => { onChange(e) }} />
                                          </div>
                                       </div>
                                       <div className="mb-1 row prl-7">
                                          <label htmlFor="inputDigit" className="col-sm-5 font11 text-right p-0 line-h20 mb-0">Module Position :</label>
                                          <div className="col-sm-7 pl-2 pr-0">
                                             <select className="form-select inputborder w-100 font11" name="modulePosition" value={moduleMasterCreationObj.modulePosition} onChange={(e) => { onChange(e) }}>
                                                {modulePositionList}
                                             </select>
                                          </div>
                                       </div>
                                       <div className="mb-1 row prl-7">
                                          <label htmlFor="inputSymbol" className="col-sm-5 font11 text-right p-0 line-h20 mb-0">Icon Path:</label>
                                          <div className="col-sm-7 p-0 pl-2">
                                             <input type="text" className="inputborder font11 w-100 h20" maxLength="50" name="iconPath" value={moduleMasterCreationObj.iconPath} onChange={(e) => { onChange(e) }} />
                                          </div>
                                       </div>
                                       <div className="mb-1 row prl-7">
                                          <label htmlFor="inputSymbol" className="col-sm-5 font11 text-right p-0 line-h20 mb-0">M Symbol Status:</label>
                                          <div className="col-sm-7 p-0 pl-2">
                                             <div className="form-check-inline w-25 radio-margin">
                                                <label className="form-check-label">
                                                   <input type="radio" className="form-check-input" name="moduleStatus" value={true} onChange={(e) => { onChange(e) }} checked={!!moduleMasterCreationObj && !!moduleMasterCreationObj.moduleStatus} />Active
                                                </label>
                                             </div>
                                             <div className="form-check-inline w-25">
                                                <label className="form-check-label">
                                                   <input type="radio" className="form-check-input" name="moduleStatus" value={false} onChange={(e) => { onChange(e) }} checked={!!moduleMasterCreationObj && !moduleMasterCreationObj.moduleStatus} />Inactive
                                                </label>
                                             </div>
                                          </div>
                                       </div>

                                    </div>
                                    <div className="col-6">
                                       <div className="mb-1 row prl-7">
                                          <label htmlFor="inputSymbol" className="col-sm-5 font11 text-right p-0 line-h20 mb-0">Module Name:</label>
                                          <div className={`col-sm-7 p-0 pl-2 ${moduleNameError && 'error'}`}>
                                             <input type="text" className="inputborder font11 w-100 h20" maxLength="50" name="moduleName" value={moduleMasterCreationObj.moduleName} onChange={(e) => { onChange(e) }} disabled={!!isEdit ? true : false} />
                                          </div>
                                       </div>
                                       <div className="mb-1 row prl-7">
                                          <label htmlFor="inputDigit" className="col-sm-5 font11 text-right p-0 line-h20 mb-0">Parent Module:</label>
                                          <div className="col-sm-7 pl-2 pr-0">
                                             <select className="form-select inputborder w-100 font11" name="parentModule" value={moduleMasterCreationObj.parentModule} onChange={(e) => { onChange(e) }}>
                                                <option value="0">Select Parent Module</option>
                                                {!!parentModulesObj && !!moduleMasterCreationObj && !!moduleMasterCreationObj.moduleFor && Object.keys(parentModulesObj[moduleMasterCreationObj.moduleFor]).length > 0 && Object.keys(parentModulesObj[moduleMasterCreationObj.moduleFor]).map(mid => {
                                                   return (
                                                      <option value={mid} key={mid + 1}>{parentModulesObj[moduleMasterCreationObj.moduleFor][mid]}</option>
                                                   )
                                                })}
                                             </select>
                                          </div>
                                       </div>
                                       <div className="mb-1 row prl-7">
                                          <label htmlFor="inputSymbol" className="col-sm-5 font11 text-right p-0 line-h20 mb-0">Module URL:</label>
                                          <div className="col-sm-7 p-0 pl-2">
                                             <input type="text" className="inputborder font11 w-100 h20" maxLength="50" name="moduleUrl" value={moduleMasterCreationObj.moduleUrl} onChange={(e) => { onChange(e) }} />
                                          </div>
                                       </div>
                                       <div className="mb-1 row prl-7">
                                          <label htmlFor="inputSymbol" className="col-sm-5 font11 text-right p-0 line-h20 mb-0">Module Description:</label>
                                          <div className="col-sm-7 p-0 pl-2">
                                             <input type="text" className="inputborder font11 w-100 h20" maxLength="50" name="moduleDescription" value={moduleMasterCreationObj.moduleDescription} onChange={(e) => { onChange(e) }} />
                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-12">
                                       <div className="mb-1  prl-7">
                                          <label htmlFor="inputSymbol" className="d-inline-block font11 line-h20 mb-0 p-0 text-right wid-121mdpop">Module Access:</label>
                                          <div className="d-inline-block p-0 pl-2">
                                             <div className="form-check-inline  radio-margin">
                                                <label className="form-check-label">
                                                   <input type="checkbox"
                                                      className="form-check-input"
                                                      name="moduleAdd"
                                                      value={moduleMasterCreationObj.moduleAdd}
                                                      checked={moduleMasterCreationObj?.moduleAdd}
                                                      onChange={(e) => { onChange(e, !moduleMasterCreationObj.moduleAdd) }}
                                                   />Add
                                                </label>
                                             </div>
                                             <div className="form-check-inline  radio-margin">
                                                <label className="form-check-label">
                                                   <input type="checkbox"
                                                      name="moduleEdit"
                                                      className="form-check-input"
                                                      value={moduleMasterCreationObj.moduleEdit}
                                                      checked={moduleMasterCreationObj?.moduleEdit}
                                                      onChange={(e) => { onChange(e, !moduleMasterCreationObj.moduleEdit) }}
                                                   />Edit
                                                </label>
                                             </div>
                                             <div className="form-check-inline  radio-margin">
                                                <label className="form-check-label">
                                                   <input type="checkbox"
                                                      name="moduleDelete"
                                                      className="form-check-input"
                                                      value={moduleMasterCreationObj.moduleDelete}
                                                      checked={moduleMasterCreationObj?.moduleDelete}
                                                      onChange={(e) => { onChange(e, !moduleMasterCreationObj.moduleDelete) }}
                                                   />Delete
                                                </label>
                                             </div>
                                             <div className="form-check-inline  radio-margin">
                                                <label className="form-check-label">
                                                   <input type="checkbox"
                                                      name="moduleView"
                                                      className="form-check-input"
                                                      value={moduleMasterCreationObj.moduleView}
                                                      checked={moduleMasterCreationObj?.moduleView}
                                                      onChange={(e) => { onChange(e, !moduleMasterCreationObj.moduleView) }}
                                                   />View
                                                </label>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           }
                           {popupActiveTab === 2 &&
                              <div className=''>
                                 <div className="fidderbox-inner office-height-modulemaster ">
                                    <div>
                                       <div className="d-flex mb-2">
                                          <label htmlFor="inputDigit" className="font11 line-h20 mb-0 p-0 text-right">Parent Module:</label>
                                          <div className="pl-2 pr-0 w-200">
                                             <select className="form-select inputborder w-100 font11" value={moduleForAdminDealer} onChange={(e) => onChangingOfSelection(e.target.value)}>
                                                <option value='Admin'>Admin</option>
                                                <option value='Dealer'>Dealer</option>
                                             </select>
                                          </div>
                                       </div>
                                    </div>
                                    <table className="table table-bordered table-strip w-100 mb-0">
                                       <tbody>
                                          <tr className="thead-dard-bg">
                                             <td className="">Module</td>
                                             <td className="office-user-w">Add</td>
                                             <td className="office-user-w">Edit</td>
                                             <td className="office-user-w">Delete</td>
                                             <td className="office-user-w">View</td>
                                          </tr>
                                          {(!!filteredGroupingMapModules && filteredGroupingMapModules.length > 0) ? filteredGroupingMapModules?.sort((a, b) => a.displayName.localeCompare(b.displayName)).map((item, index) => {
                                             return (
                                                <tr key={`${item?.moduleId}_${index}`}>
                                                   <td>{item.displayName}</td>
                                                   <td>
                                                      <input
                                                         id={`${item?.moduleId}moduleAdd`}
                                                         className="form-check-input ml-1"
                                                         type="checkbox"
                                                         name={`${item?.moduleId}_moduleAdd`}
                                                         value={item?.moduleAdd}
                                                         checked={item?.moduleAdd}
                                                         onChange={(e) => {
                                                            onChange(
                                                               e, item, "Rights-moduleAdd"
                                                            );
                                                         }}
                                                      />
                                                   </td>
                                                   <td>
                                                      <input
                                                         id={`${item?.moduleId}moduleEdit`}
                                                         className="form-check-input ml-1"
                                                         type="checkbox"
                                                         name={`${item?.moduleId}_moduleEdit`}
                                                         value={item?.moduleEdit}
                                                         checked={item?.moduleEdit}
                                                         onChange={(e) => {
                                                            onChange(
                                                               e, item, "Rights-moduleEdit"
                                                            );
                                                         }}
                                                      />
                                                   </td>
                                                   <td>
                                                      <input
                                                         id={`${item?.moduleId}moduleDelete`}
                                                         className="form-check-input ml-1"
                                                         type="checkbox"
                                                         name={`${item?.moduleId}_moduleDelete`}
                                                         value={item?.moduleDelete}
                                                         checked={item?.moduleDelete}
                                                         onChange={(e) => {
                                                            onChange(
                                                               e, item, "Rights-moduleDelete"
                                                            );
                                                         }}
                                                      />
                                                   </td>
                                                   <td>
                                                      <input
                                                         id={`${item?.moduleId}moduleView`}
                                                         className="form-check-input ml-1"
                                                         type="checkbox"
                                                         name={`${item?.moduleId}_moduleView`}
                                                         value={item?.moduleView}
                                                         checked={item?.moduleView}
                                                         onChange={(e) => {
                                                            onChange(
                                                               e, item, "Rights-moduleView"
                                                            );
                                                         }}
                                                      />
                                                   </td>
                                                </tr>
                                             )
                                          }) : <NoDataError colspn={5} />}
                                       </tbody>
                                    </table>
                                 </div>

                              </div>
                           }
                        </div>
                     </div>
                  </div>
               </Modal.Body>
               <Modal.Footer>
                  <div>
                     <div className="w-100 text-right p-1">
                        <Button className="btnmain mr-3" onClick={() => { onSubmitModuleMaster() }}>
                           {disableSubmitBtn && <i className="fa fa-spinner fa-spin mr-2"></i>}Submit
                        </Button>
                        <Button onClick={() => closeModuleMasterAddModal()} className="btnmain-danger">
                           Cancel
                        </Button>
                     </div>
                  </div>
               </Modal.Footer>
            </Modal>
         </div>
      </>
   );

}
export default ModuleMaster;
